import { BookkeepingItemType } from '@features/reconciliation/enums/bookkeepingItemType'
import { BookkeepingItem } from '@features/reconciliation/types/bookkeepingItem'

import { EmberRoute } from '../../../../../../../enums/emberRoute'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'

export const getBookkeepingItemRoute = (item: BookkeepingItem): string => {
  switch (item.type) {
    case BookkeepingItemType.Invoice:
      return EmberRoute.Invoice
    case BookkeepingItemType.Bill:
      return reactRoute.organization.bills.getViewBillRoute(item.id)
    case BookkeepingItemType.ExternalInvoice:
      return reactRoute.organization.invoices.getViewInvoiceRoute(
        item.externalId,
        item.isCreditNote ? 'creditNote' : 'invoice',
      )
    case BookkeepingItemType.Posting:
      return EmberRoute.Transaction
    default:
      return ''
  }
}
